export var RATE_LIMITED = 503;
export var CONTENT_FILTERED = 422;
export var MESSAGE_LENGTH_EXCEEDED = 413;
export var CONVERSATION_RESET = 'RESET';